import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/abrir-conta')({
  component: AbrirContaRedirect,
})

function AbrirContaRedirect() {
  useEffect(() => {
    const q = window.location.search || ''
    window.location.replace(`/cadastro${q}`)
  }, [])
  return (
    <div className="flex min-h-svh items-center justify-center text-muted-foreground text-sm">
      Redirecionando…
    </div>
  )
}
